import spacing from "./spacing.styles";

export const fontFamily =
  "Ideal Sans SSm A, Ideal Sans SSm B, Helvetica Neue, Helvetica, Arial, sans-serif";
export const fontFamilySans = "Helvetica Neue, Helvetica, Arial, sans-serif";
export const fontFamilyFutura = 'Futura, "Trebuchet MS", Arial, sans-serif';
export const fontFamilyGooglePrimary = "'Google Sans',Roboto,Arial,sans-serif";
export const fontFamilyGoogleSecondary = "Roboto, Helvetica Neue, Helvetica, Arial, sans-serif";

// These are the two fontFamilies use in Figma mocks. Aliasing for ease of use.
export const fontFamilyIdealSans = fontFamily;
export const fontFamilyHelvetica = fontFamilySans;

export const size = {
  xs: 11,
  sm: 12,
  md: 14,
  std: 16,
  lg: 18,
  xl: 24,
  xxl: 32,
};

export const weight: { std: 400; bold: 700 } = {
  std: 400,
  bold: 700,
};

export const lineHeight: { std: 1.4; lg: 1.8 } = {
  std: 1.4,
  lg: 1.8,
};

export const h1 = {
  fontSize: size.xl,
  marginBottom: spacing.std,
};

export const h2 = {
  fontSize: size.lg,
  marginBottom: spacing.sm,
};

export const p = {
  fontSize: size.md,
  lineHeight: 1.5,
};
